import {ChangeEvent, useState} from 'react';
import sdk from '@/sdk';
import ConfirmDialog from '@/components/ConfirmDialog';
import {DialogBody, DialogFoot} from '@/components/Dialog';
import Checkbox from '@/components/Checkbox';
import Button, {ButtonSize} from '@/components/Button';
import Icon, {IconSize} from '@/components/Icon';
import {SidebarTeamSvg} from '@/icons/index';
import styles from './index.module.scss';

function SidebarDragDialog({visible, dragData, onCancel, onConfirm}: any) {
    const [isChecked, setIsChecked] = useState(false);
    const {moveType, rootName} = dragData || {};

    function handleChange(e: ChangeEvent<Element>, checked: boolean) {
        setIsChecked(checked);
    }

    function renderToastConfirm() {
        if (!moveType) {
            return '';
        }
        let content: any = '';
        if (moveType === 'docToDir' || moveType === 'dirToDir') {
            content = (<div>
                <div>移动后，当前页面将自动继承知识本</div>
                <div className={styles.nodeContent}>
                    <Icon svg={SidebarTeamSvg} size={IconSize.LG} noSpace />
                    <span className={styles.moveText}>{rootName}</span> 权限
                </div>
            </div>);
        } else if (moveType === 'dirToDoc') {
            content = (<div>
                <div>移动后，当前页面不再继承知识本</div>
                <div className={styles.nodeContent}>
                    <Icon svg={SidebarTeamSvg} size={IconSize.LG} noSpace />
                    <span className={styles.moveText}>{rootName}</span> 权限
                </div>
            </div>);
        }
        return (
            <div>{content}</div>
        );
    }

    function handleCancel() {
        onCancel && onCancel();
        setIsChecked(false);
    }

    // 用户层关闭拖拽到知识本提示
    async function updateMoveInBook() {
        await sdk.as.updateNewGuide({
            moveInBook: true,
        });
    }

    // 用户层关闭知识本拖拽到文档提示
    async function updateMoveOutBook() {
        await sdk.as.updateNewGuide({
            moveOutBook: true,
        });
    }

    function closeMoveHint() {
        if (moveType === 'docToDir' || moveType === 'dirToDir') {
            updateMoveInBook();
        } else if (moveType === 'dirToDoc') {
            updateMoveOutBook();
        }
    }

    function handleConfirm() {
        isChecked && closeMoveHint();
        onConfirm && onConfirm(dragData);
        setIsChecked(false);
    }

    if (!visible) {
        return null;
    }

    return (
        <ConfirmDialog
            visible={visible}
            showHeader={false}
            className={styles.confirm}
        >
            <DialogBody>
                {renderToastConfirm()}
            </DialogBody>
            <DialogFoot className={styles.dialogFoot}>
                <Checkbox
                    checked={isChecked}
                    onChange={handleChange}
                    className={styles.checkBox}
                    size={'sm'}
                >
                    不再提示
                </Checkbox>
                <div className={styles.BtnShow}>
                    <Button
                        size={ButtonSize.MD}
                        shape={'circle'}
                        className={styles.btnBox}
                        onClick={handleCancel}
                    >取消</Button>
                    <Button
                        size={ButtonSize.MD}
                        shape={'circle'}
                        type={'important'}
                        className={styles.btnBox}
                        onClick={handleConfirm}
                    >确定</Button>
                </div>
            </DialogFoot>
        </ConfirmDialog>
    );
}

export default SidebarDragDialog;
